module.exports = __webpack_public_path__ + "static/media/TrellisBackgroundQ17.478d2fef.JPG";